import settings from "rizzo-next/sass/settings.json";

/**
 * Return a font stack
 * @param  {String} family The name of the fony family stored in the settings
 * @return {String}        Font stack
 */
function font(family) {
  return settings.font.family[family] ?
    settings.font.family[family].join(", ") :
    "";
}

export default font;



// WEBPACK FOOTER //
// ./assets/pois/utils/font.js